// Copyright 2019 Sorama B.V.

export enum WorkflowPropertyBindingMode {
    /** Changes propagate only from Workflow (URI) to Workflow Module. **/
    oneWay,

    /** Changes propagate both ways (URI to Workflow Module and vice versa). **/
    twoWay,
}

export enum WorkflowPropertyScope {
    /** Property is synced workflow wide */
    workflow,

    /** Property value is unique per workflow module */
    workflowModule,

    /** A specific link between two WorkflowModules. Can be one way. */
    workflowModuleSet,
}

export enum WorkflowPropertyStateScope {
    /**
     * The state is shared between modules. Restoring this state will result in applying this new property value for the whole workflow (as defined in the WorkflowPropertyScope)
     */
    workflow,

    /**
     * Property is unique for this module and is not shared
     */
    workflowModule,
}

export interface LocalStoredDefaultValue {
    /**
     * An override for the group key. Correspond the the module, if not defined
     */
    group?: string;
    key: string;
    defaultValue?: unknown;
}

export interface IWorkflowPropertyMetadataSettings {
    /** Binding mode of this property */
    bindingMode: WorkflowPropertyBindingMode;

    /**
     * Default: using metadata to retrieve object type. Mandatory with ModuleSet scope.
     */
    objectType?: string;

    /** Scope of this property within an existing workflow*/
    scope?: WorkflowPropertyScope;

    scopeIdx?: number;

    changedHandler?: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    defaultValue?: any;
}
